export const formatWeekDate = (dateStr) => {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
  });
};

export const filterStudentsBySearch = (students, searchValue) => {
  if (!searchValue) return students;
  const lowerSearch = searchValue.toLowerCase();
  return students.filter((student) => {
    const fullName = `${student.firstName} ${student.lastName}`.toLowerCase();
    const email = (student.email || '').toLowerCase();
    return fullName.includes(lowerSearch) || email.includes(lowerSearch);
  });
};

export const toRoundedPercent = (grade) => {
  if (grade == null) return null;
  return Math.round(grade * 100);
};

export const formatGrade = (grade) => {
  const rounded = toRoundedPercent(grade);
  if (rounded == null) return '--';
  return `${rounded}%`;
};

export const formatChange = (current, previous) => {
  const roundedCurrent = toRoundedPercent(current);
  const roundedPrevious = toRoundedPercent(previous);
  if (roundedCurrent == null || roundedPrevious == null) return '--';
  const change = roundedCurrent - roundedPrevious;
  if (change > 0) return `+${change}%`;
  if (change < 0) return `${change}%`;
  return '0%';
};
